/**
 * Analysis Service
 * All analysis-related API calls (quick, deep, job status, summaries)
 */

import { apiClient } from '../client';
import type {
    QuickAnalysisRequest,
    QuickAnalysisResult,
    DeepAnalysisRequest,
    DeepAnalysisJob,
    ProjectAnalysisSummary,
} from '../../../entities/analysis';

export const analysisService = {
    /** Run a quick SAST analysis (immediate results) */
    runQuickAnalysis: (data: QuickAnalysisRequest) =>
        apiClient.post<QuickAnalysisResult>('/analysis/quick', data),

    /** Start a deep ML analysis (async — Pro/Enterprise only) */
    runDeepAnalysis: (data: DeepAnalysisRequest) =>
        apiClient.post<DeepAnalysisJob>('/analysis/deep', data),

    /** Get the status of a deep analysis job */
    getJobStatus: (jobId: string) =>
        apiClient.get<DeepAnalysisJob>(`/analysis/job/${jobId}`),

    /** Get the analysis summary for a project */
    getProjectSummary: (projectId: string) =>
        apiClient.get<ProjectAnalysisSummary>(`/analysis/project/${projectId}/summary`),
};
